import { createContext } from 'react';
import { GetTotemClosedDaysQuery } from 'data/__generated__';

export type ClosedDay = GetTotemClosedDaysQuery['getTotemClosedDays'][number];

export const TotemClosedDaysContext = createContext<ClosedDay[]>([]);
